export default __webpack_public_path__ + "static/media/magnifierPlus.d5d495e3.svg";